/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { InstitutionSelectorGridDto } from './InstitutionSelectorGridDto';
import {
    InstitutionSelectorGridDtoFromJSON,
    InstitutionSelectorGridDtoFromJSONTyped,
    InstitutionSelectorGridDtoToJSON,
} from './InstitutionSelectorGridDto';

/**
 * 
 * @export
 * @interface InstitutionSelectorGridDtoPaginatedResults
 */
export interface InstitutionSelectorGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof InstitutionSelectorGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<InstitutionSelectorGridDto>}
     * @memberof InstitutionSelectorGridDtoPaginatedResults
     */
    results?: Array<InstitutionSelectorGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof InstitutionSelectorGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the InstitutionSelectorGridDtoPaginatedResults interface.
 */
export function instanceOfInstitutionSelectorGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstitutionSelectorGridDtoPaginatedResultsFromJSON(json: any): InstitutionSelectorGridDtoPaginatedResults {
    return InstitutionSelectorGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function InstitutionSelectorGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutionSelectorGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(InstitutionSelectorGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function InstitutionSelectorGridDtoPaginatedResultsToJSON(value?: InstitutionSelectorGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(InstitutionSelectorGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

